import { css, StyleDeclarationValue } from 'aphrodite';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router';
import { ErrorMessagesViewModelKey } from '../../../models/AppState';
import { IEventLoggingComponentProps, withEventLogging } from '../../../models/Logging';
import { WarningIcon } from '../svgs/icons/WarningIcon';
import { styleSheet } from './styles';
import { Button } from '../../components-v2/Button';
import { AppLayout } from '../../components-v2/AppLayout';

interface IProps extends IEventLoggingComponentProps, RouteComponentProps<any> {
	className?: string;
	styles?: StyleDeclarationValue[];
}

interface IState {
	hasError: boolean;
}

class _ErrorBoundary extends React.Component<React.PropsWithChildren<IProps>, IState> {
	public readonly state: IState = { hasError: false };

	public static getDerivedStateFromError() {
		return { hasError: true };
	}

	public componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
		const { logError } = this.props;

		logError('ErrorBoundary-Error', error, errorInfo);
	}

	private onGoToDash = () => {
		const { history } = this.props;
		history.push('/dashboard');
		this.setState({ hasError: false });
	};

	public render() {
		const { className, styles } = this.props;
		const { hasError } = this.state;

		if (hasError) {
			return (
				<AppLayout>
					<div className={`${css(styleSheet.container, ...(styles || []))} ${className || ''}`}>
						<div>
							<WarningIcon />
							<div className={css(styleSheet.title)}>An error occurred</div>
							<div className={css(styleSheet.description)}>Please return to the dashboard or refresh the page.</div>
							<Button onClick={this.onGoToDash} styles={[styleSheet.button]}>
								Go to dashboard
							</Button>
						</div>
					</div>
				</AppLayout>
			);
		}

		return this.props.children;
	}
}

const ErrorBoundaryAsObserver = observer(_ErrorBoundary);
const ErrorBoundaryWithLogging = withEventLogging(ErrorBoundaryAsObserver, 'Crash');
const ErrorBoundaryWithRouter = withRouter(ErrorBoundaryWithLogging);
export const ErrorBoundary = inject(ErrorMessagesViewModelKey)(ErrorBoundaryWithRouter);
